// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home.css */
.primary-button {
  background: #4589cd;
  color: white;
  border: none;
  padding: 12px 25px;
  font-size: 1rem;
  border-radius: 27px;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 2px;
}

.secondary-button {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 12px 25px;
  font-size: 1.1rem;
  border-radius: 27px;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 2px;
  font-weight: 600;
}

.primary-button:hover {
  background: #0052a3;
  transform: translateY(-2px);
}

.secondary-button:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.about {
  background-color: var(--secondary-light);
}

.about-section {
  padding: 80px 0;

}

.about-content {
  display: flex;
  gap: 50px;
  align-items: center;
  
}

.about-text {
  flex: 1 1;
}

.about-image {
  flex: 1 1;
}

.about-image img {
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* Team Section Styles */
.team-section {
  padding: 80px 0;
  background: var(--secondary-dark);
}

.team-grid {
  display: grid;
  grid-template-rows: repeat(auto-fit, minmax(280px, 1fr));
  grid-auto-rows: auto;
  gap: 30px;
}

#team .section-title {
  color: var(--text-medium);
}

#team .section-title::after {
  background-color: var(--text-medium);
}

#team .position {
  margin-bottom: 0.5%;
}

#team .qualification, .qualification2, .qualification3 {
  font-size: 0.7em;
  margin-bottom: 0;
}

#team .qualification3 {
  margin-bottom: 7%;
}

/* Shared Styles */
.feature {
  padding: 20px;
  border-left: 3px solid var(--primary-blue);
}

.team-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}


/* .map-section {
  padding: 80px 0;
  background: #F9F7EE;
}

.map-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.map-info-card {
  position: absolute;
  top: 30px;
  right: 30px;
  background: white;
  padding: 25px;
  border-radius: 8px;
  max-width: 300px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
} */

/* MapSection.css */
/* .map-section {
  padding: 5rem 0;
  background: white;
}

.map-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;
}

.map-wrapper {
  height: 400px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.location-details {
  padding: 2rem;
}

.location-details h3 {
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
}

.detail-item {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  align-items: flex-start;
}

.detail-item i {
  color: #0066cc;
  font-size: 1.2rem;
  margin-top: 0.2rem;
}

.detail-item h4 {
  color: #2c3e50;
  margin-bottom: 0.3rem;
  font-size: 1.1rem;
}

.detail-item p {
  color: #5a6a7a;
  line-height: 1.6;
}

.cta-button {
  background: #0066cc;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 500;
  margin-top: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.cta-button:hover {
  background: #0052a3;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
} */

/* MapSection.css - Mobile First Approach */
.map-section {
  padding: 2rem 0;
  background-color: var(--secondary-light);

}

.map-container {
  display: grid;
  grid-template-areas:
    "map"
    "details";
  gap: 2rem;
  max-width: 100%;
}

.map-wrapper {
  grid-area: map;
  width: 100%;
  margin: 0 auto;
}

.location-details {
  grid-area: details;
  text-align: center;
  margin: 0 auto;
  max-width: 500px;
}

/* Center all child elements */
.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 1.5rem;
}

.icon-circle {
  background: #ecf5f6;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-circle i {
  color: var(--text-dark);
  font-size: 1rem;
}

.detail-item h4 {
  color: #2c3e50;
  margin-bottom: 0.25rem;
  font-size: 1rem;
}

.detail-item address,
.detail-item p,
.detail-item a {
  color: #5a6a7a;
  line-height: 1.5;
  font-size: 0.9rem;
  font-style: normal;
}

.detail-item a {
  text-decoration: none;
  transition: color 0.2s;
}

.detail-item a:hover {
  color: #0066cc;
  text-decoration: underline;
}

.map-section .cta-button {
  background: var(--primary-blue);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  /* font-weight: 600; */
  font-size: 1rem;
  letter-spacing: 1.2px;
  cursor: pointer;
  transition: all 0.3s;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}



/* Tablet (768px and up) */
@media (min-width: 768px) {
  .map-section {
    padding: 3rem 0;
  }

  .map-container {
    grid-template-areas: "map details";
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }

  .location-details {
    text-align: left;
    padding-left: 2rem;
    margin: 0;
  }

  .detail-item {
    flex-direction: row;
    align-items: flex-start;
    text-align: left;
    gap: 1rem;
  }

  .map-wrapper {
    height: 350px;
  }

  .cta-button {
    width: auto;
    padding: 0.75rem 1.75rem;
  }
}

/* Desktop (992px and up) */
@media (min-width: 992px) {
  .map-container {
    flex-direction: row;
    gap: 2rem;
    align-items: center;
  }

  .map-wrapper {
    flex: 1 1;
    height: 400px;
    order: 0;
    /* Reset order for desktop */
  }

  .location-details {
    flex: 1 1;
    padding: 0 0 0 2rem;
  }

  .detail-item {
    gap: 1.25rem;
    margin-bottom: 1.5rem;
  }

  .icon-circle {
    width: 44px;
    height: 44px;
  }

  .icon-circle i {
    font-size: 1.1rem;
  }
}


/* Mobile */
/* Responsive Adjustments */
@media (max-width: 992px) {
  .about-content {
    flex-direction: column;
  }

  .about-image {
    order: -1;
    margin-bottom: 30px;
  }

  .about-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
    max-height: 300px;
    /* Mobile height limit */
  }

  .map-container {
    grid-template-columns: 1fr;
  }

  .map-wrapper {
    height: 300px;
    order: -1;
  }

  .location-details {
    padding: 1rem 0;
  }
}

/* Large Desktop (1200px and up) */
@media (min-width: 1200px) {
  .map-wrapper {
    height: 450px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;AAErB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;;AAGA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH,mBAAmB;AACnB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyEG;;AAEH,2CAA2C;AAC3C;EACE,eAAe;EACf,wCAAwC;;AAE1C;;AAEA;EACE,aAAa;EACb;;aAEW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;;;AAIA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,QAAQ;IACR,4BAA4B;EAC9B;;EAEA;IACE,SAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA,WAAW;AACX,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Home.css */\n.primary-button {\n  background: #4589cd;\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  font-size: 1rem;\n  border-radius: 27px;\n  cursor: pointer;\n  transition: all 0.3s;\n  letter-spacing: 2px;\n}\n\n.secondary-button {\n  background: transparent;\n  color: white;\n  border: 2px solid white;\n  padding: 12px 25px;\n  font-size: 1.1rem;\n  border-radius: 27px;\n  cursor: pointer;\n  transition: all 0.3s;\n  letter-spacing: 2px;\n  font-weight: 600;\n}\n\n.primary-button:hover {\n  background: #0052a3;\n  transform: translateY(-2px);\n}\n\n.secondary-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n.about {\n  background-color: var(--secondary-light);\n}\n\n.about-section {\n  padding: 80px 0;\n\n}\n\n.about-content {\n  display: flex;\n  gap: 50px;\n  align-items: center;\n  \n}\n\n.about-text {\n  flex: 1;\n}\n\n.about-image {\n  flex: 1;\n}\n\n.about-image img {\n  border-radius: 8px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* Team Section Styles */\n.team-section {\n  padding: 80px 0;\n  background: var(--secondary-dark);\n}\n\n.team-grid {\n  display: grid;\n  grid-template-rows: repeat(auto-fit, minmax(280px, 1fr));\n  grid-auto-rows: auto;\n  gap: 30px;\n}\n\n#team .section-title {\n  color: var(--text-medium);\n}\n\n#team .section-title::after {\n  background-color: var(--text-medium);\n}\n\n#team .position {\n  margin-bottom: 0.5%;\n}\n\n#team .qualification, .qualification2, .qualification3 {\n  font-size: 0.7em;\n  margin-bottom: 0;\n}\n\n#team .qualification3 {\n  margin-bottom: 7%;\n}\n\n/* Shared Styles */\n.feature {\n  padding: 20px;\n  border-left: 3px solid var(--primary-blue);\n}\n\n.team-card {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n}\n\n\n/* .map-section {\n  padding: 80px 0;\n  background: #F9F7EE;\n}\n\n.map-container {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n}\n\n.map-info-card {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  max-width: 300px;\n  box-shadow: 0 3px 10px rgba(0,0,0,0.1);\n} */\n\n/* MapSection.css */\n/* .map-section {\n  padding: 5rem 0;\n  background: white;\n}\n\n.map-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n.map-wrapper {\n  height: 400px;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.location-details {\n  padding: 2rem;\n}\n\n.location-details h3 {\n  color: #2c3e50;\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n}\n\n.detail-item {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  align-items: flex-start;\n}\n\n.detail-item i {\n  color: #0066cc;\n  font-size: 1.2rem;\n  margin-top: 0.2rem;\n}\n\n.detail-item h4 {\n  color: #2c3e50;\n  margin-bottom: 0.3rem;\n  font-size: 1.1rem;\n}\n\n.detail-item p {\n  color: #5a6a7a;\n  line-height: 1.6;\n}\n\n.cta-button {\n  background: #0066cc;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-weight: 500;\n  margin-top: 1rem;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cta-button:hover {\n  background: #0052a3;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n} */\n\n/* MapSection.css - Mobile First Approach */\n.map-section {\n  padding: 2rem 0;\n  background-color: var(--secondary-light);\n\n}\n\n.map-container {\n  display: grid;\n  grid-template-areas:\n    \"map\"\n    \"details\";\n  gap: 2rem;\n  max-width: 100%;\n}\n\n.map-wrapper {\n  grid-area: map;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.location-details {\n  grid-area: details;\n  text-align: center;\n  margin: 0 auto;\n  max-width: 500px;\n}\n\n/* Center all child elements */\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.icon-circle {\n  background: #ecf5f6;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.icon-circle i {\n  color: var(--text-dark);\n  font-size: 1rem;\n}\n\n.detail-item h4 {\n  color: #2c3e50;\n  margin-bottom: 0.25rem;\n  font-size: 1rem;\n}\n\n.detail-item address,\n.detail-item p,\n.detail-item a {\n  color: #5a6a7a;\n  line-height: 1.5;\n  font-size: 0.9rem;\n  font-style: normal;\n}\n\n.detail-item a {\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.detail-item a:hover {\n  color: #0066cc;\n  text-decoration: underline;\n}\n\n.map-section .cta-button {\n  background: var(--primary-blue);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  /* font-weight: 600; */\n  font-size: 1rem;\n  letter-spacing: 1.2px;\n  cursor: pointer;\n  transition: all 0.3s;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n\n\n/* Tablet (768px and up) */\n@media (min-width: 768px) {\n  .map-section {\n    padding: 3rem 0;\n  }\n\n  .map-container {\n    grid-template-areas: \"map details\";\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n  }\n\n  .location-details {\n    text-align: left;\n    padding-left: 2rem;\n    margin: 0;\n  }\n\n  .detail-item {\n    flex-direction: row;\n    align-items: flex-start;\n    text-align: left;\n    gap: 1rem;\n  }\n\n  .map-wrapper {\n    height: 350px;\n  }\n\n  .cta-button {\n    width: auto;\n    padding: 0.75rem 1.75rem;\n  }\n}\n\n/* Desktop (992px and up) */\n@media (min-width: 992px) {\n  .map-container {\n    flex-direction: row;\n    gap: 2rem;\n    align-items: center;\n  }\n\n  .map-wrapper {\n    flex: 1;\n    height: 400px;\n    order: 0;\n    /* Reset order for desktop */\n  }\n\n  .location-details {\n    flex: 1;\n    padding: 0 0 0 2rem;\n  }\n\n  .detail-item {\n    gap: 1.25rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .icon-circle {\n    width: 44px;\n    height: 44px;\n  }\n\n  .icon-circle i {\n    font-size: 1.1rem;\n  }\n}\n\n\n/* Mobile */\n/* Responsive Adjustments */\n@media (max-width: 992px) {\n  .about-content {\n    flex-direction: column;\n  }\n\n  .about-image {\n    order: -1;\n    margin-bottom: 30px;\n  }\n\n  .about-image img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n    max-height: 300px;\n    /* Mobile height limit */\n  }\n\n  .map-container {\n    grid-template-columns: 1fr;\n  }\n\n  .map-wrapper {\n    height: 300px;\n    order: -1;\n  }\n\n  .location-details {\n    padding: 1rem 0;\n  }\n}\n\n/* Large Desktop (1200px and up) */\n@media (min-width: 1200px) {\n  .map-wrapper {\n    height: 450px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
